import React from "react";
import { TextArea } from "@truevault/aquilo";
import { CONSENT_TEXTAREA_CLASSES } from "../../../consentBanner/consentFieldStyles";
import { ConsentLinkButton, ConsentSettingRow } from "../../../consentBanner/ConsentSettingRow";

interface ConsentBannerUSTextRowProps {
  formApi: { change: (field: string, value: string) => void };
  informationalBannerDefaultText: string;
}

export const ConsentBannerUSTextRow = ({
  formApi,
  informationalBannerDefaultText,
}: ConsentBannerUSTextRowProps) => {
  return (
    <ConsentSettingRow
      title="Banner text"
      helpText="Required while any region uses the informational banner."
    >
      <div className="w-full">
        <TextArea
          field="informationalBannerText"
          className={CONSENT_TEXTAREA_CLASSES}
          aria-label="Informational banner text"
          rows={5}
          required
        />
      </div>
      <ConsentLinkButton
        onClick={() => formApi.change("informationalBannerText", informationalBannerDefaultText)}
      >
        Reset to default
      </ConsentLinkButton>
    </ConsentSettingRow>
  );
};
